import {
  checkEmail,
  checkUsername,
  checkPhone,
  selectAuth,
} from "store/slices/auth.slice";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";

const useInputCheck = () => {
  const { checks } = useSelector(selectAuth);
  const dispatch = useDispatch();

  const mapChecks = (type) => (value) => {
    const map = {
      email: (value) => checkEmail(value),
      username: (value) => checkUsername(value),
      phone: (value) => checkPhone(value),
    };

    return map[type](value);
  };

  const getChecks = (type) => {
    return checks[type];
  };

  const makeCheck = useCallback(
    (type, value) => dispatch(mapChecks(type)(value)),
    [dispatch]
  );

  return { makeCheck, check: getChecks };
};

export default useInputCheck;
